export const KEYS = {
  // TEST
  RAZORPAY_KEY: "rzp_test_QZiObId0zurPJT",
  RAZORPAY_PRIVATE: "oF6YnOICO3is9H5LH969CuCn",

  // LIVE
  // RAZORPAY_KEY: "rzp_live_IdbpP23t1c2VMe",
  // RAZORPAY_PRIVATE: "AMGSFEAgIBJpW2I27mrdnVmd",
};
